module.exports = __webpack_public_path__ + "img/title7.56e1772a.png";